import lodash from 'lodash';
import config from "./config";
import configDev from './config.develop';

let mergeConfig = config;
if (process.env.VUE_APP_BLUE_DOT === "develop") {
  mergeConfig = lodash.merge(config, configDev);
};

export default mergeConfig;